var map = {
	"./logo.jpg": "4Uwr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "px/K";


//////////////////
// WEBPACK FOOTER
// ./src/assets nonrecursive ^\.\/logo.(png|jpe?g|svg)$
// module id = px/K
// module chunks = 1